var React = require('react');

function QuadArrowRightIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M16.5,7.4c-0.3,0.3-0.3,0.9,0,1.2c0,0,0,0,0,0l1.6,1.6l0.9,0.9H9.6c-0.5,0-0.9,0.4-0.9,0.9\n\tc0,0.2,0.1,0.5,0.3,0.6c0.2,0.2,0.4,0.3,0.6,0.3H19l-0.9,0.9l-1.6,1.6c-0.3,0.3-0.3,0.9,0,1.2c0.3,0.3,0.9,0.3,1.2,0l0,0l4-4l0,0\n\tl0,0l0,0c0.3-0.3,0.3-0.9,0-1.2l0,0l0,0l0,0l-4-4C17.4,7.1,16.9,7.1,16.5,7.4","key":0}),React.createElement("path",{"fill":"currentColor","d":"M12.4,17.6v-3.4h2.3v4.9c0,0.5-0.3,0.9-0.8,0.9H2.8C2.3,20,2,19.6,2,19.1V4.9C2,4.4,2.3,4,2.8,4h11.1\n\tc0.5,0,0.8,0.4,0.8,0.9v4.7h-2.3V6.4h-8v11.2C4.3,17.6,12.4,17.6,12.4,17.6z","key":1})]);
}

QuadArrowRightIcon.defaultProps = {"data-dmid":"dm-quad-arrow-right","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = QuadArrowRightIcon;

QuadArrowRightIcon.default = QuadArrowRightIcon;
